export default __webpack_public_path__ + "static/media/Arrow_left.3b6f04a5.svg";